'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

function _getAnchorPositions(target){
const rect=target.getBoundingClientRect();
const halfWidth=rect.width*0.5;
const halfHeight=rect.height*0.5;

const{top:top,bottom:bottom,left:left,right:right}=rect;

const positions={
topLeft:{x:left,y:top},
top:{x:left+halfWidth,y:top},
topRight:{x:right,y:top},
right:{x:right,y:top+halfHeight},
bottomRight:{x:right,y:bottom},
bottom:{x:left+halfWidth,y:bottom},
bottomLeft:{x:left,y:bottom},
left:{x:left,y:top+halfHeight},
center:{x:left+halfWidth,y:top+halfHeight}};


return positions;
}

function _getAlignmentOffsets(element,anchor){
const rect=element.getBoundingClientRect();
const fullWidth=rect.width;
const fullHeight=rect.height;
const halfWidth=rect.width*0.5;
const halfHeight=rect.height*0.5;

const{x:x,y:y}=anchor;

const alignmentSides={
topLeft:{x:x,y:y},
top:{x:x-halfWidth,y:y},
topRight:{x:x-fullWidth,y:y},
right:{x:x-fullWidth,y:y-halfHeight},
bottomRight:{x:x-fullWidth,y:y-fullHeight},
bottom:{x:x-halfWidth,y:y-fullHeight},
bottomLeft:{x:x,y:y-fullHeight},
left:{x:x,y:y-halfHeight},
center:{x:x-halfWidth,y:y-halfHeight}};


return alignmentSides;
}

function _getTooltipPosition(target,element,anchorSide,alignmentSide,cb){
fastdom.measure(function(){
if(!_.exists(target)||!_.exists(element)){
return;
}

const anchorPositions=_getAnchorPositions(target);
const anchor=anchorPositions[anchorSide];
const alignedPoints=_getAlignmentOffsets(element,anchor);
cb(alignedPoints[alignmentSide]);
});
}

const _getTooltipHtml=function(directive,anchorPosition,alignPosition){return(
`<div class="tooltip-container ${directive}-container anchor-position-${anchorPosition} align-position-${alignPosition}">
		<${directive} class="tooltip-directive-container"/>
	</div>`)};let

TooltipService=function(_BaseService){_inherits(TooltipService,_BaseService);
function TooltipService($rootScope,$window,$compile,$timeout){_classCallCheck(this,TooltipService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$compile=$compile;
_this._tooltipsRoot=angular.element('#tooltips');
_this._windowElement=angular.element($window);

_this._tooltipsContainer=null;
_this._currentTarget=null;
_this._scope=null;
_this._$timeout=$timeout;

_this._repositionTooltip=_this._repositionTooltip.bind(_this);
_this.closeTooltip=_this.closeTooltip.bind(_this);

$rootScope.$on('resize::resize',_this.closeTooltip);
$rootScope.$on('$stateChangeSuccess',_this.closeTooltip);return _this;
}TooltipService.prototype.





updateTooltipPosition=function updateTooltipPosition(alignmentOptions,target,containerElement){
this._$timeout(function(){
const{anchorToTargetSide:anchorToTargetSide,alignFromTooltipSide:alignFromTooltipSide}=alignmentOptions;

_getTooltipPosition(target,containerElement[0],anchorToTargetSide,alignFromTooltipSide,function(_ref){let{x:x,y:y}=_ref;
fastdom.mutate(function(){return _.attempt(function(){return containerElement.css({transform:`translate(${x}px, ${y}px)`})})});
});
});
};TooltipService.prototype.

_repositionTooltip=function _repositionTooltip(){var _this2=this;
if(!_.allExist(this._currentTarget,this._scope)){
return;
}

fastdom.measure(function(){
const target=_this2._currentTarget;
const container=angular.element('#tooltips .tooltip-container');

if(!_.allExist(container,_this2._scope)){
return;
}

const{anchorToTargetSide:anchorToTargetSide,alignFromTooltipSide:alignFromTooltipSide}=_this2._scope;

_getTooltipPosition(target,container[0],anchorToTargetSide,alignFromTooltipSide,function(_ref2){let{x:x,y:y}=_ref2;
fastdom.mutate(function(){return _.attempt(function(){return container.css({transform:`translate(${x}px, ${y}px)`})})});
});
});
};TooltipService.prototype.

openTooltip=function openTooltip(scope,target){var _this3=this;
this._currentTarget=target;
this._scope=scope;

const htmlTemplate=_getTooltipHtml(scope.directive,scope.anchorToTargetSide,scope.alignFromTooltipSide);
const compiledHtml=this._$compile(htmlTemplate)(scope);

fastdom.mutate(function(){
_this3._tooltipsRoot.html(compiledHtml);

fastdom.measure(function(){

const tooltipTemplateDirective=_this3._tooltipsRoot.find(`${scope.directive} .tooltip-body`);
if(tooltipTemplateDirective.length===0)return;

_this3._setupEventHandlers();

angular.element('#tooltips .tooltip-container .tooltip-directive-container').addClass('open');
_this3._repositionTooltip();
});
});
};TooltipService.prototype.

closeTooltip=function closeTooltip(){
this._removeEventHandlers();



this._tooltipsRoot.empty();

if(_.exists(this._currentTarget)){
this._currentTarget=null;
}

if(_.exists(this._scope)){
this._scope.$destroy();
this._scope=null;
}
};TooltipService.prototype.

_setupEventHandlers=function _setupEventHandlers(){
this._windowElement.on('click',this.closeTooltip);
this._enableRepositioningOnScroll();
};TooltipService.prototype.

_removeEventHandlers=function _removeEventHandlers(){
this._windowElement.off('click',this.closeTooltip);
this._disableRepositioningOnScroll();
};TooltipService.prototype.

_enableRepositioningOnScroll=function _enableRepositioningOnScroll(){
const _scrollbarElement=angular.element('.pulsar-scrollbar');

if(!_.exists(_scrollbarElement)){
return;
}

_scrollbarElement.on('scroll',this._repositionTooltip);
};TooltipService.prototype.

_disableRepositioningOnScroll=function _disableRepositioningOnScroll(){
const _scrollbarElement=angular.element('.pulsar-scrollbar');

if(!_.exists(_scrollbarElement)){
return;
}

_scrollbarElement.off('scroll',this._repositionTooltip);
};_createClass(TooltipService,[{key:'currentTarget',get:function(){return this._currentTarget}}]);return TooltipService}(BaseService);


module.exports=TooltipService;
//# sourceMappingURL=tooltipService.js.map
